import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import swal from 'sweetalert';

import {withStyles} from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

class ArchiveButton extends React.Component {

    static propTypes = {
        href: PropTypes.string.isRequired,
        confirmMessage: PropTypes.string,
        successMessage: PropTypes.string,
        errorMessage: PropTypes.string,
        handleSuccess: PropTypes.func,
    };

    static defaultProps = {
        confirmMessage: '',
        successMessage: '',
        errorMessage: '',
    };

    async onArchiveClicked() {
        const confirm = await swal({
            text: this.props.confirmMessage,
            dangerMode: true,
            buttons: true,
        });

        if (confirm) {
            // Confirmed to delete item.
            await this.archiveItem();
        }
    }

    async archiveItem() {
        try {
            console.log(this.props.href);
            // Send request.
            let { data } = await axios.post(this.props.href);

            console.log(data);

            // Show success message.
            await swal({
                text: this.props.successMessage,
                icon: "success",
            });

            // Refresh page to update data.
            this.props.handleSuccess ? this.props.handleSuccess() : location.reload()
        } catch (e) {
            // Show error in case of exception.
            swal({
                text: this.props.errorMessage,
                icon: "error",
            });
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <IconButton
                onClick={this.onArchiveClicked.bind(this)}
                title={this.props.text}
            >
                <Icon>archive</Icon>
            </IconButton>
        );
    }
}

const styles = theme => ({
    dangerButton: {
        color: red[500],
    },
});

export default withStyles(styles)(ArchiveButton);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/ArchiveButton.js